import s from "styled-components";
import { Link as RouterLink } from "react-router-dom";
import { Button } from "_c/button";

export const Title = s.h3`
  color: var(--font-color-emp);
  font-size: 18px;
  font-weight: 500;
  margin: 0;
  margin-bottom: 15px;
  user-select: none; 

`;
export const Wrap = s.div`
  position: relative;
  padding: 25px 0px;
  z-index: 2;
  padding-bottom: 0;
  border-radius: 9px;
  background-color: var(--bg-elevate);
  overflow: hidden;
  @media(max-width: 991px) {
    width: 80%;
    margin: 0 auto;
  }
  @media(max-width: 767px) {
    width: 100%;
  }
  @media(max-width: 575px) {
    width: 95%;
  }
`;
export const Sect = s.div`
  position: relative;
  margin-bottom: 20px;
  max-height: 300px;
  padding-bottom: 25px;
  padding-left: 20px;
  padding-right: 20px;
  border-bottom: 2px solid #fffce9;
  :last-child {
    border-bottom: 0;
    margin-bottom: 0;
  }
`;
export const HistorySect = s(Sect)`
  overflow-y: auto;
  ::-webkit-scrollbar-track {
    background-color: white;
    border-radius: 45px;
  }
  ::-webkit-scrollbar {
    width: 7px;
    background-color: #fff;
    border-radius: 45px;
  }
  ::-webkit-scrollbar-thumb {
    background-image: linear-gradient(to right, #5c1084 0%, #9e317f 100%);
    border-radius: 45px;
  }

`;

export const BasketWrap = s.div`
  display: flex;
  align-items: center;
`;
export const BasketIconWrap = s.span`
  display: flex;
  width: 70px;
  height: 70px;
  position: relative;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  background: #fffce9;
`;
export const BasketCount = s.div`
  position: absolute;
  bottom: 4px;
  right: -2px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background-color: var(--color-primary);
  color: white;
  font-weight: 600;
  font-size: 12px;
`;
export const BasketServicesWrap = s.div`
  display: flex;
  margin-left: 10px;
  flex-direction: column;
  font-size: 14px;
  font-weight: 600;
  color: #706671;
`;
export const ServicesAmount = s.span`
  color: var(--font-color-accent);
  margin-bottom: 5px;
`;
export const PayButton = s(Button)`
  color: #ffffff;
  padding-left: 20px;
  padding-right: 20px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 40px;
  margin-left: 15px;
  box-shadow: 0px 8px 50px -13px rgba(212,23,157,1);
  transition: box-shadow .35s ease-in-out;
  :hover {
    box-shadow: 0px 8px 60px -10px rgba(212,23,157,1); 
  }
  @media(max-width: 991px) {
    margin-left: 15px;
  }
`;
export const Avatar = s.img`
  width: 50px;
  height: 50px;
  margin-right: 20px;
  border-radius: 50%;
  object-fit: cover;
`;
export const HistoryItem = s.li`
  margin-bottom: 12px;
  :last-child {
    margin-bottom: 0;
  }
`;
export const Link = s(RouterLink)`
  display: flex;
  align-items: center;
  color: #706671;
  font-size: 14px;
  font-weight: 600;
  transition: opacity .35s ease-in-out;
  :hover {
    opacity: .7;
  }
`;
export const SliderWrap = s.div`
  position: relative;
`;
